import { render } from "./v-radio.vue?vue&type=template&id=2fde4cd5"
import script from "./v-radio.vue?vue&type=script&lang=js"
export * from "./v-radio.vue?vue&type=script&lang=js"

import "./v-radio.vue?vue&type=style&index=0&id=2fde4cd5&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__